const home = {
  path: "home",
  component: resolve => require(["../../../../pages/user/course/home"], resolve)
};
export default home;



// WEBPACK FOOTER //
// ./src/router/user/course/home/index.js